import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import NoPermissionContainer from '@SonarCX/components/molecules/NoPermissionContainer'
import SettingsSection from '../../SettingsSection'
import TagV2 from '@SonarCX/components/molecules/EHAccordion/TagBlockV2/TagV2'

import { fetchTags, removeTag, selectTag } from '@SonarCX/slices/tag'
import { useAreYouSure } from '@SonarCX/providers/AreYouSureProvider'
import useStyles from './styles'

const Tags = () => {
  const dispatch = useAppDispatch()

  const { tags: serverTags, loading, loaded } = useAppSelector(selectTag)

  const { setAction, setSubtext, setTitle, setV2 } = useAreYouSure()

  const classes = useStyles()

  const sortedTags = React.useMemo(
    () => [...serverTags].sort((a, b) => a.localeCompare(b)),
    [serverTags]
  )

  React.useEffect(() => {
    if (loaded || loading) return
    dispatch(fetchTags())
  }, [dispatch, loaded, loading])

  const handleOnDelete = React.useCallback(
    (tag: string) => {
      setSubtext("This tag won't appear on the list anymore.")
      setTitle('ARE YOU SURE?')
      setAction(() => dispatch(removeTag(tag)))
      setV2(true)
    },
    [dispatch, setAction, setSubtext, setTitle, setV2]
  )

  return (
    <NoPermissionContainer skipAgentPage error={false}>
      <SettingsSection title='Tags' loaded={loaded}>
        <div className={classes.root}>
          {sortedTags.map((tag, index) => (
            <TagV2
              key={`${index}-${tag}`}
              tag={tag}
              onDelete={() => handleOnDelete(tag)}
            />
          ))}
        </div>
      </SettingsSection>
    </NoPermissionContainer>
  )
}

export default Tags
